import { Moon, Sun, MonitorSmartphone } from 'lucide-react';
import type { ThemeMode } from '../stores/themeStore';

interface Option {
  value: ThemeMode;
  label: string;
  ariaLabel: string;
  Icon: typeof Sun;
}

const OPTIONS: Option[] = [
  { value: 'light', label: 'Claro', ariaLabel: 'Tema claro', Icon: Sun },
  { value: 'dark', label: 'Oscuro', ariaLabel: 'Tema oscuro', Icon: Moon },
  {
    value: 'system',
    label: 'Sistema',
    ariaLabel: 'Tema del sistema',
    Icon: MonitorSmartphone,
  },
];

interface ThemeToggleProps {
  theme: ThemeMode;
  onChange: (theme: ThemeMode) => void;
}

export function ThemeToggle({ theme, onChange }: ThemeToggleProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Tema de la interfaz"
      className="inline-flex items-center gap-0.5 rounded-lg border border-neutral-200 bg-neutral-50 p-0.5 dark:border-neutral-300 dark:bg-neutral-100"
    >
      {OPTIONS.map((opt) => {
        const selected = opt.value === theme;
        const Icon = opt.Icon;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={opt.ariaLabel}
            title={opt.label}
            onClick={() => onChange(opt.value)}
            className={`flex h-8 w-8 items-center justify-center rounded-md transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-focus-ring)] ${
              selected
                ? 'bg-neutral-0 dark:text-neutral-0 text-neutral-900 shadow-[var(--shadow-ambient-low)] dark:bg-neutral-900'
                : 'text-neutral-500 hover:bg-neutral-100 hover:text-neutral-700 dark:text-neutral-400 dark:hover:bg-neutral-200 dark:hover:text-neutral-900'
            }`}
          >
            <Icon className="h-4 w-4" aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}
